import { ShieldCheck } from 'lucide-react';
import '../FooterTrust.css';

export const FooterTrust = () => (
  <div className="footer-trust" role="group" aria-label="Regulación y apoyo institucional" data-testid="footer-trust">
    <div className="footer-trust-badge footer-trust-cmf" data-testid="footer-cmf-badge">
      <ShieldCheck size={23} strokeWidth={1.8} aria-hidden="true" />
      <span data-testid="footer-cmf-label">CORREDORA CERTIFICADA CMF · CHILE</span>
    </div>
    <div className="footer-trust-badge footer-trust-corfo" data-testid="footer-corfo-badge">
      <span data-testid="footer-corfo-label">EMPRESA APOYADA POR</span>
      <img src="/images/corfo-user-reference.png" alt="CORFO" width="172" height="53" loading="lazy" data-testid="footer-corfo-logo" />
    </div>
  </div>
);